<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { SCModalNext, SCButton, ButtonVariant } from '@nsftx/seven-components'
import { useBetslip } from '@nsftx/seven-client-retail-vue-sgp'
import { useTicketCheckStore } from '@/stores/ticket-check/ticketCheckStore'
import { useTicketRebet } from '@/composables/useTicketRebet/useTicketRebet'
import STTicketCheckDetailsBet from './STTicketCheckDetailsBet.vue'

const TICKET_CHECK_DETAILS_MODAL_WIDTH = '1400px'

const ticketCheckStore = useTicketCheckStore()
const { isTicketCheckDetailsOpened } = storeToRefs(ticketCheckStore)
const { closeTicketCheckDetailsModal } = ticketCheckStore
const { bets } = useBetslip()
const { rebetTicket } = useTicketRebet()

const handleRebet = async () => {
  await rebetTicket()
  closeTicketCheckDetailsModal()
}
</script>

<template>
  <SCModalNext
    v-model="isTicketCheckDetailsOpened"
    :width="TICKET_CHECK_DETAILS_MODAL_WIDTH"
    with-close-icon
    class="st-ticket-check-details"
  >
    <template #content>
      <STTicketCheckDetailsBet v-for="bet in bets" :key="bet.id" :bet />
      <div class="st-flex-between sc-pt-6">
        <SCButton
          :variant="ButtonVariant.Primary"
          data-cy="ticketRebetButton"
          data-testid="st-ticket-rebet-button"
          @click="handleRebet"
        >
          {{ $t('common_rebet') }}
        </SCButton>
        <SCButton
          :variant="ButtonVariant.Primary"
          data-cy="closeTicketCheckDetailsModalButton"
          @click="closeTicketCheckDetailsModal"
        >
          {{ $t('common_close') }}
        </SCButton>
      </div>
    </template>
  </SCModalNext>
</template>

<style lang="scss">
.sc-modal-next__panel {
  &__content {
    overflow-y: auto;
    flex-direction: column;
  }
}
</style>
